/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';

import styles from './toggle.module.scss';

type IToggleSwitch = {
  checked: boolean;
  onChange: Function;
};

const ToggleSwitchComponent = (props: IToggleSwitch): JSX.Element => {
  const { checked, onChange } = props;
  const handleChange = () => {
    onChange();
  };

  return (
    <label htmlFor="recordingToggle" className={styles['switch-label']}>
      Recording
      <div className="relative ml-2">
        <input
          type="checkbox"
          id="recordingToggle"
          className="sr-only"
          checked={checked}
          // onChange={handleChange}
        />
        <div onClick={handleChange}>
          <div className={`${styles['switch-background']}`}>
            <span>OFF</span>
            <span>ON</span>
          </div>
          <div
            className={`${styles['switch-dot']} ${
              checked ? 'right-1 ' : 'left-1'
            }`}
          >
            {checked ? 'ON' : 'OFF'}
          </div>
        </div>
      </div>
    </label>
  );
};

export default ToggleSwitchComponent;
